import { IMinerTypeSelectorProps } from "./MinerTypeSelector.props";
import { useMinerTypeSelectorControl } from "./useMinerTypeSelectorControl";
import MinerTypeOption from "./MinerTypeOption/MinerTypeOption";
import CommonSelector from "../CommonSelector/CommonSelector";

export default function MinerTypeSelector(props: IMinerTypeSelectorProps) {

  const control = useMinerTypeSelectorControl(props);

  return (
    <CommonSelector
      showSearch
      className={props.className}
      id={props.id}
      hasPrevText={!props.withoutPrevText}
      hasCleanUp
      name={props.name}
      options={control.minerProfiles.map((p) => ({
        id: p.id,
        text: p.name,
      }))}
      currentValue={
        props.value && {
          id: props.value.id,
          text: props.value.name,
        }
      }
      onCleanUp={props.onClearClick}
      onChange={control.onGetMinerProfile}
      clearedValue={props.hasDefaultValue ? control.CLEARED_VALUE : undefined}
      reset={props.reset}
      renderOption={(id) => {
        if (control.CLEARED_VALUE.id === id) {
          return control.CLEARED_VALUE.text;
        }
        const profile = control.minerProfiles.find(
          (mp) => Number(mp.id) === Number(id)
        );
        if (!profile) return null;
        return <MinerTypeOption {...profile} algo={profile.hash} />;
      }}
    />
  );
}
